module.exports = __webpack_public_path__ + "img/4-a-squoll-participant-reponse-sondage-sm.c5776861.png";